/**
 * Checks if the browser has an active internet connection.
 */
export const isInternetReachable = async (): Promise<boolean> => {
  if (typeof window !== 'undefined' && 'navigator' in window) {
    return window.navigator.onLine;
  }
  return true;
};
